/* Rising Sun FPV - Find my filament colour.
   Data: sections/filament-data.liquid via /collections/<handle>?section_id=filament-data
   Colour per filament: variant metafield custom.colour_hex (edit it on the variant in admin to correct a swatch). */
(function(){
  var root = document.querySelector('[data-fmc]');
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var coll = root.dataset.collection;
  var $ = function(s){ return root.querySelector(s); };
  var ITEMS = [], target = '#D92A2A', shown = 12;
  var FINISHES = ['Solid','Matte','Silk','Transparent','Neon','Glow','Sparkle','Fibre filled','Marble'];
  var MATERIALS = ['PLA','PETG','TPU / flexible','ABS','ASA','PC','Nylon','Other'];
  var state = { brand:'all', material:'all', finishes: new Set(FINISHES), instock:false };
  var money = function(c){ return '$' + (c/100).toFixed(2); };

  /* ---------- colour maths (sRGB -> CIELAB, CIEDE2000) ---------- */
  function hexToRgb(h){ h = h.replace('#',''); return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)]; }
  function rgbToHex(r){ return '#' + r.map(function(v){ return ('0'+Math.round(v).toString(16)).slice(-2); }).join('').toUpperCase(); }
  function lin(c){ c/=255; return c<=0.04045 ? c/12.92 : Math.pow((c+0.055)/1.055,2.4); }
  function toLab(rgb){
    var r=lin(rgb[0]),g=lin(rgb[1]),b=lin(rgb[2]);
    var x=(r*0.4124564+g*0.3575761+b*0.1804375)/0.95047, y=(r*0.2126729+g*0.7151522+b*0.0721750), z=(r*0.0193339+g*0.1191920+b*0.9503041)/1.08883;
    var f=function(t){ return t>0.008856 ? Math.cbrt(t) : 7.787*t+16/116; };
    var fx=f(x),fy=f(y),fz=f(z); return [116*fy-16,500*(fx-fy),200*(fy-fz)];
  }
  function de2000(a,b){
    var L1=a[0],a1=a[1],b1=a[2],L2=b[0],a2=b[1],b2=b[2],rad=Math.PI/180;
    var C1=Math.hypot(a1,b1),C2=Math.hypot(a2,b2),Cm=(C1+C2)/2,G=0.5*(1-Math.sqrt(Math.pow(Cm,7)/(Math.pow(Cm,7)+Math.pow(25,7))));
    var a1p=(1+G)*a1,a2p=(1+G)*a2,C1p=Math.hypot(a1p,b1),C2p=Math.hypot(a2p,b2);
    var h1p=Math.atan2(b1,a1p)/rad; if(h1p<0)h1p+=360; var h2p=Math.atan2(b2,a2p)/rad; if(h2p<0)h2p+=360;
    var dLp=L2-L1,dCp=C2p-C1p,dhp=0; if(C1p*C2p!==0){ dhp=h2p-h1p; if(dhp>180)dhp-=360; else if(dhp<-180)dhp+=360; }
    var dHp=2*Math.sqrt(C1p*C2p)*Math.sin(dhp*rad/2),Lpm=(L1+L2)/2,Cpm=(C1p+C2p)/2,hpm=h1p+h2p;
    if(C1p*C2p!==0){ hpm = Math.abs(h1p-h2p)>180 ? (h1p+h2p+(h1p+h2p<360?360:-360))/2 : (h1p+h2p)/2; }
    var T=1-0.17*Math.cos((hpm-30)*rad)+0.24*Math.cos(2*hpm*rad)+0.32*Math.cos((3*hpm+6)*rad)-0.20*Math.cos((4*hpm-63)*rad);
    var dth=30*Math.exp(-Math.pow((hpm-275)/25,2)),Rc=2*Math.sqrt(Math.pow(Cpm,7)/(Math.pow(Cpm,7)+Math.pow(25,7)));
    var Sl=1+0.015*Math.pow(Lpm-50,2)/Math.sqrt(20+Math.pow(Lpm-50,2)),Sc=1+0.045*Cpm,Sh=1+0.015*Cpm*T,Rt=-Math.sin(2*dth*rad)*Rc;
    return Math.sqrt(Math.pow(dLp/Sl,2)+Math.pow(dCp/Sc,2)+Math.pow(dHp/Sh,2)+Rt*(dCp/Sc)*(dHp/Sh));
  }
  function label(d){ return d<2?'Near-identical':d<5?'Very close':d<10?'Close':d<20?'Similar':'Nearest we stock'; }

  /* ---------- material, finish and names from the titles ---------- */
  function material(t){
    if(/tpu|flex|peba/i.test(t)) return 'TPU / flexible';
    if(/petg|pctg|pet-/i.test(t)) return 'PETG';
    if(/\basa\b|asa-/i.test(t)) return 'ASA';
    if(/pc[-\/ ]abs/i.test(t)) return 'PC';
    if(/\babs\b/i.test(t)) return 'ABS';
    if(/nylon|polymide|\bpa\d/i.test(t)) return 'Nylon';
    if(/polycarbonate|\bpc\b|pc-pbt/i.test(t)) return 'PC';
    if(/pla/i.test(t)) return 'PLA';
    return 'Other';
  }
  function finish(t){
    if(/luminous|glow/i.test(t)) return 'Glow';
    if(/transparent|translucent|clear\b/i.test(t)) return 'Transparent';
    if(/neon|fluro|fluor/i.test(t)) return 'Neon';
    if(/silk|satin/i.test(t)) return 'Silk';
    if(/galaxy|glitter|celestial|twinkling|sparkle|shimmer/i.test(t)) return 'Sparkle';
    if(/marble/i.test(t)) return 'Marble';
    if(/carbon fib|[- ]cf\b|cf\d|[- ]gf\b|gf\d|glass fib/i.test(t)) return 'Fibre filled';
    if(/matte|polyterra/i.test(t)) return 'Matte';
    return 'Solid';
  }
  var BRANDMAP={'Rising Sun FPV':'Nova','Prusa Research':'Prusament','ELEGOO':'Elegoo'};
  function brandName(v){ return BRANDMAP[v]||v; }
  function range(pt){
    return pt.replace(/^RISING SUN FPV\s*-\s*/i,'').replace(/\s*3D Print(ing)? Filament/i,'').replace(/\s*\(?1\.75 ?mm\)?/i,'').replace(/\s*Filament\b/ig,'').replace(/\s+/g,' ').trim();
  }
  function colourName(p){
    if(p.vt==='Default Title') return range(p.pt);
    return p.vt.replace(/^(Premium )?(PLA|PETG) (?=\S)/,'').replace(/^Prusament (PC Blend|ASA|PETG|PLA) /,'').replace(/\s+\d+ ?k?g$/i,'').trim();
  }

  /* ---------- data load ---------- */
  function loadPage(n){
    return fetch('/collections/'+coll+'?section_id=filament-data&page='+n,{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(html){
      var m = html.match(/data-pages="(\d+)"[^>]*>([\s\S]*?)<\/script>/);
      if(!m) return {pages:0,items:[]};
      return {pages:+m[1],items:JSON.parse(m[2])};
    });
  }
  function load(){
    return loadPage(1).then(function(first){
      var reqs=[]; for(var i=2;i<=first.pages;i++) reqs.push(loadPage(i));
      return Promise.all(reqs).then(function(rest){
        [first].concat(rest).forEach(function(pg){ pg.items.forEach(function(a){
          if(!/^#[0-9A-F]{6}$/i.test(a[5]||'')) return;
          var both=a[2]+' '+a[3];
          ITEMS.push({id:a[0],url:a[1],pt:a[2],vt:a[3],v:a[4],hex:a[5].toUpperCase(),price:a[6],avail:a[7],img:a[8],lab:toLab(hexToRgb(a[5])),f:finish(both),m:material(a[2])});
        }); });
      });
    });
  }

  /* ---------- UI ---------- */
  function single(wrap, list, key){
    list.forEach(function(b){
      var el=document.createElement('button'); el.type='button'; el.className='fmc__opt'; el.textContent=b[1]; el.setAttribute('aria-pressed', state[key]===b[0]);
      el.onclick=function(){ state[key]=b[0]; wrap.querySelectorAll('.fmc__opt').forEach(function(x){ x.setAttribute('aria-pressed','false'); }); el.setAttribute('aria-pressed','true'); shown=12; render(); };
      wrap.appendChild(el);
    });
  }
  function buildBrands(){
    var cnt={}, list=[['all','All brands']];
    ITEMS.forEach(function(p){ cnt[p.v]=(cnt[p.v]||0)+1; });
    Object.keys(cnt).sort(function(a,b){ return cnt[b]-cnt[a]; }).forEach(function(v){ list.push([v,brandName(v)]); });
    single($('[data-brands]'), list, 'brand');
  }
  function buildMaterials(){
    var have={}, list=[['all','All materials']];
    ITEMS.forEach(function(p){ have[p.m]=1; });
    MATERIALS.forEach(function(m){ if(have[m]) list.push([m,m]); });
    single($('[data-materials]'), list, 'material');
  }
  function buildFilters(){
    var fw=$('[data-finishes]');
    FINISHES.forEach(function(f){ var el=document.createElement('button'); el.type='button'; el.className='fmc__opt'; el.textContent=f; el.setAttribute('aria-pressed', state.finishes.has(f)); el.onclick=function(){ if(state.finishes.has(f)) state.finishes.delete(f); else state.finishes.add(f); el.setAttribute('aria-pressed', state.finishes.has(f)); shown=12; render(); }; fw.appendChild(el); });
    state.instock=$('[data-instock]').checked;
    $('[data-instock]').onchange=function(e){ state.instock=e.target.checked; shown=12; render(); };
  }
  function setTarget(hex, from){
    hex = hex.toUpperCase(); target = hex; shown = 12;
    $('[data-target-sw]').style.background = hex; $('[data-target-hex]').textContent = hex;
    if(from!=='picker') $('#fmc-picker').value = hex.toLowerCase();
    if(from!=='hex') $('#fmc-hex').value = hex;
    render();
  }
  function render(){
    var list=$('[data-list]'), count=$('[data-count]');
    if(!ITEMS.length){ return; }
    var tl = toLab(hexToRgb(target));
    var pool = ITEMS.filter(function(p){ return (state.brand==='all'||p.v===state.brand) && (state.material==='all'||p.m===state.material) && state.finishes.has(p.f) && (!state.instock||p.avail); });
    pool.forEach(function(p){ p.d = de2000(tl,p.lab); });
    pool.sort(function(a,b){ return a.d-b.d || (b.avail-a.avail); });
    count.textContent = pool.length + ' filaments searched';
    var html = pool.slice(0,shown).map(function(p,i){
      var pct = Math.max(0, Math.round(100 - p.d*2.5));
      return '<li class="fmc__card">'
        + '<div class="fmc__sw"><span style="background:'+target+'"></span><span style="background:'+p.hex+'"></span><em class="fmc__sw-lab fmc__sw-lab--l">Yours</em><em class="fmc__sw-lab fmc__sw-lab--r">'+p.hex+'</em></div>'
        + '<div class="fmc__cbody"><span class="fmc__match">#'+(i+1)+' &middot; '+label(p.d)+' &middot; '+pct+'%</span>'
        + '<div class="fmc__thead">'+(p.img?'<img class="fmc__thumb" src="'+esc(p.img)+'" alt="" loading="lazy" width="46" height="46">':'')
        + '<div><p class="fmc__ptitle"><a href="'+p.url+'">'+esc(colourName(p))+'</a></p>'
        + '<p class="fmc__meta">'+esc(p.vt==='Default Title'?brandName(p.v):range(p.pt))+'</p></div></div>'
        + '<p class="fmc__meta">'+esc(brandName(p.v))+' &middot; '+esc(p.m)+' &middot; '+esc(p.f)+'</p>'
        + '<div class="fmc__foot"><span class="fmc__pw"><span class="fmc__price">'+money(p.price)+'</span><span class="fmc__stock '+(p.avail?'is-in':'is-out')+'">'+(p.avail?'In stock':'Out of stock')+'</span></span>'
        + (p.avail ? '<button type="button" class="fmc__btn fmc__add" data-add="'+p.id+'">Add to cart</button>' : '<a class="fmc__btn fmc__btn--ghost fmc__add" style="margin:0;width:auto" href="'+p.url+'">View</a>')
        + '</div></div></li>';
    }).join('');
    list.innerHTML = html || '<li class="fmc__empty">No filament matches these filters. Try another material, turn more finishes back on, or untick Hide out of stock.</li>';
    $('[data-more]').hidden = pool.length <= shown;
  }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  root.addEventListener('click', function(e){
    var add = e.target.closest('[data-add]');
    if(add){
      add.disabled = true; var old = add.textContent; add.textContent = 'Adding...';
      fetch((window.routes && window.routes.cartAddUrl || '/cart/add') + '.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:+add.dataset.add,quantity:1})})
        .then(function(r){ if(!r.ok) throw r; return r.json(); })
        .then(function(){ add.textContent='Added'; document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}})); document.documentElement.dispatchEvent(new CustomEvent('product:added',{bubbles:true,detail:{quantity:1}})); setTimeout(function(){ add.textContent=old; add.disabled=false; },1800); })
        .catch(function(){ add.textContent='Could not add'; setTimeout(function(){ add.textContent=old; add.disabled=false; },2000); });
      return;
    }
    var chip = e.target.closest('[data-hex]'); if(chip){ setTarget(chip.dataset.hex); return; }
    var tab = e.target.closest('[data-tab]');
    if(tab){ root.querySelectorAll('[data-tab]').forEach(function(t){ var on=t===tab; t.classList.toggle('is-active',on); t.setAttribute('aria-selected',on); }); root.querySelectorAll('[data-pane]').forEach(function(p){ p.classList.toggle('is-active',p.dataset.pane===tab.dataset.tab); }); }
  });
  $('[data-more]').onclick = function(){ shown += 12; render(); };
  $('#fmc-picker').addEventListener('input', function(e){ setTarget(e.target.value,'picker'); });
  function hexGo(){
    var v = $('#fmc-hex').value.trim().replace(/^#/,''), msg=$('[data-hex-msg]');
    if(/^[0-9a-f]{3}$/i.test(v)) v = v.split('').map(function(c){ return c+c; }).join('');
    if(!/^[0-9a-f]{6}$/i.test(v)){ msg.textContent='That is not a valid hex code. Try something like D92A2A.'; msg.classList.add('is-err'); return; }
    msg.textContent='Six characters, with or without the #.'; msg.classList.remove('is-err'); setTarget('#'+v,'hex');
  }
  $('[data-hex-go]').onclick = hexGo;
  $('#fmc-hex').addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); hexGo(); } });

  /* ---------- photo picking ---------- */
  var cv=$('[data-canvas]'), cx=cv.getContext('2d',{willReadFrequently:true}), loupe=$('[data-loupe]');
  $('[data-file]').addEventListener('change', function(e){
    var f=e.target.files && e.target.files[0]; if(!f) return;
    var img=new Image(), url=URL.createObjectURL(f);
    img.onload=function(){
      var s=Math.min(1,1000/Math.max(img.width,img.height)); cv.width=Math.round(img.width*s); cv.height=Math.round(img.height*s);
      cx.drawImage(img,0,0,cv.width,cv.height); URL.revokeObjectURL(url);
      $('[data-canvaswrap]').hidden=false; loupe.hidden=true; dominant();
    };
    img.src=url;
  });
  function sampleAt(clientX, clientY){
    var r=cv.getBoundingClientRect(), x=Math.round((clientX-r.left)*cv.width/r.width), y=Math.round((clientY-r.top)*cv.height/r.height);
    var R=4, d=cx.getImageData(Math.max(0,x-R),Math.max(0,y-R),R*2+1,R*2+1).data, s=[0,0,0], n=0;
    for(var i=0;i<d.length;i+=4){ s[0]+=d[i]; s[1]+=d[i+1]; s[2]+=d[i+2]; n++; }
    loupe.hidden=false; loupe.style.left=(clientX-r.left)+'px'; loupe.style.top=(clientY-r.top)+'px';
    var hex=rgbToHex(s.map(function(v){ return v/n; })); loupe.style.background=hex; setTarget(hex);
  }
  cv.addEventListener('pointerdown', function(e){ cv.setPointerCapture(e.pointerId); sampleAt(e.clientX,e.clientY); });
  cv.addEventListener('pointermove', function(e){ if(e.buttons) sampleAt(e.clientX,e.clientY); });
  function dominant(){
    var w=60, h=Math.max(1,Math.round(60*cv.height/cv.width)), t=document.createElement('canvas'); t.width=w; t.height=h;
    var tc=t.getContext('2d'); tc.drawImage(cv,0,0,w,h); var d=tc.getImageData(0,0,w,h).data, px=[];
    for(var i=0;i<d.length;i+=4) px.push([d[i],d[i+1],d[i+2]]);
    var k=6, cents=[]; for(var j=0;j<k;j++) cents.push(px[Math.floor((j+0.5)*px.length/k)].slice());
    for(var it=0;it<8;it++){
      var sums=cents.map(function(){ return [0,0,0,0]; });
      px.forEach(function(p){ var bi=0,bd=1e9; cents.forEach(function(c,ci){ var dd=(p[0]-c[0])*(p[0]-c[0])+(p[1]-c[1])*(p[1]-c[1])+(p[2]-c[2])*(p[2]-c[2]); if(dd<bd){bd=dd;bi=ci;} }); var s=sums[bi]; s[0]+=p[0]; s[1]+=p[1]; s[2]+=p[2]; s[3]++; });
      cents=sums.map(function(s,ci){ return s[3]? [s[0]/s[3],s[1]/s[3],s[2]/s[3],s[3]] : cents[ci]; });
    }
    cents.sort(function(a,b){ return (b[3]||0)-(a[3]||0); });
    var uniq=[]; cents.forEach(function(c){ if(!c[3]) return; if(uniq.every(function(u){ return Math.abs(u[0]-c[0])+Math.abs(u[1]-c[1])+Math.abs(u[2]-c[2])>36; })) uniq.push(c); }); cents=uniq;
    var wrap=$('[data-dominant-chips]'); wrap.innerHTML='';
    cents.forEach(function(c){ var hx=rgbToHex(c.slice(0,3)); var b=document.createElement('button'); b.type='button'; b.className='fmc__chip'; b.style.setProperty('--c',hx); b.dataset.hex=hx; b.setAttribute('aria-label','Use '+hx); wrap.appendChild(b); });
    $('[data-dominant]').hidden=false;
  }

  buildFilters();
  $('[data-target-sw]').style.background = target;
  load().then(function(){ buildBrands(); buildMaterials(); render(); }).catch(function(){ $('[data-count]').textContent='Could not load the filament list. Please refresh the page.'; });
})();